/** Plain-language labels for Instagram OSINT artefact types and surfaces. */

export const ARTIFACT_LABELS: Record<string, string> = {
    crypto_address: 'Crypto wallet',
    tx_hash: 'Transaction hash',
    upi_id: 'UPI ID',
    upi_payee_name: 'UPI payee name',
    phone: 'Phone',
    email: 'Email',
    handle: 'Handle / username',
    url: 'URL',
    qr_payload: 'QR content',
    utr: 'UTR / RRN',
    ifsc: 'IFSC',
    bank_account: 'Bank account',
    pan: 'PAN',
};

export const SURFACE_LABELS: Record<string, string> = {
    bio: 'Bio',
    post: 'Post',
    reel: 'Reel',
    profile: 'Profile contact',
};

export const SURFACE_STYLES: Record<string, string> = {
    bio: 'bg-pink-500/15 text-pink-600 border border-pink-500/30',
    post: 'bg-secondary text-secondary-foreground',
    reel: 'bg-violet-500/15 text-violet-600 border border-violet-500/30',
    profile: 'bg-blue-500/15 text-blue-600 border border-blue-500/30',
};

/** Group keys for results UX. */
export const PAYMENT_TYPES = new Set([
    'crypto_address',
    'tx_hash',
    'upi_id',
    'upi_payee_name',
    'utr',
    'ifsc',
    'bank_account',
    'qr_payload',
]);
export const IDENTITY_TYPES = new Set(['phone', 'email', 'handle', 'pan']);

export function groupArtifacts<T extends { artifact_type: string }>(items: T[]) {
    const payment: T[] = [];
    const identity: T[] = [];
    const other: T[] = [];
    for (const a of items) {
        if (PAYMENT_TYPES.has(a.artifact_type)) payment.push(a);
        else if (IDENTITY_TYPES.has(a.artifact_type)) identity.push(a);
        else other.push(a);
    }
    return { payment, identity, other };
}
